module.exports = __webpack_public_path__ + "img/serviceGuide-center-bg.6c8fcac.png";